import { motion } from 'framer-motion'
import { GradientBackground } from './GradientBackground'
import { useProjects } from '../hooks/useProjects'

const allImages = [
  '/IMG/OVE/Screenshot 2026-01-04 091138.png',
  '/IMG/OVE/Screenshot 2026-01-04 091157.png',
  '/IMG/OVE/Screenshot 2026-01-04 091223.png',
  '/IMG/OVE/Screenshot 2026-01-04 091250.png',
]

export function ProjectOVE() {
  const { getRandomProject } = useProjects()
  
  const handleNextProject = () => {
    const randomProject = getRandomProject('ove')
    if (randomProject) {
      window.location.hash = randomProject.slug
    }
  }
  
  return (
    <GradientBackground>
      <section className="relative h-[65vh] w-full">
        <img 
          src="/IMG/OVE/Screenshot 2026-01-04 091138.png" 
          alt="OVE"
          className="w-full h-full object-cover object-center"
        />
      </section>

      <section className="py-20 px-4" style={{ background: 'linear-gradient(to bottom, transparent 0%, #CFCFCF 100%)' }}>
        <div className="container mx-auto max-w-4xl">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16"
          >
            <div>
              <h3 className="text-sm uppercase tracking-wider text-white/60 mb-2">Client</h3>
              <p className="text-lg font-medium text-white">OVE</p>
            </div>
            <div>
              <h3 className="text-sm uppercase tracking-wider text-white/60 mb-2">Services</h3>
              <p className="text-lg font-medium text-white">Digital Design</p>
            </div>
            <div>
              <h3 className="text-sm uppercase tracking-wider text-white/60 mb-2">Year</h3>
              <p className="text-lg font-medium text-white">2024</p>
            </div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-8">The Project</h2>
            <p className="text-xl text-white/80 leading-relaxed mb-12">
              Digital project for OVE.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
              {allImages.map((src, index) => (
                <motion.img
                  key={src}
                  src={src}
                  alt={`OVE ${index + 1}`}
                  className="w-full rounded-lg shadow-lg"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.05 }}
                  loading="lazy"
                />
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      <section className="py-16 px-4 bg-[#CFCFCF]">
        <div className="container mx-auto max-w-4xl">
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="/#works"
              className="group relative inline-flex items-center justify-center gap-2 px-8 py-4 text-white text-lg font-medium rounded-lg overflow-hidden cursor-pointer transition-transform duration-300 hover:scale-105"
              style={{
                background: 'linear-gradient(90deg, #7ec876 0%, #4da6ff 50%, #7ec876 100%)',
                backgroundSize: '200% 100%',
                animation: 'gradient-shift 3s ease infinite'
              }}
            >
              <span className="relative z-10">← Back to Works</span>
              <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300" />
            </a>
            <button 
              onClick={handleNextProject}
              className="group relative inline-flex items-center justify-center gap-2 px-8 py-4 text-white text-lg font-medium rounded-lg overflow-hidden cursor-pointer transition-transform duration-300 hover:scale-105"
              style={{
                background: 'linear-gradient(90deg, #7ec876 0%, #4da6ff 50%, #7ec876 100%)',
                backgroundSize: '200% 100%',
                animation: 'gradient-shift 3s ease infinite'
              }}
            >
              <span className="relative z-10">Next Project →</span>
              <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300" />
            </button>
          </div>
        </div>
      </section>
      
      <style>{`
        @keyframes gradient-shift {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </GradientBackground>
  )
}
